<template lang="pug">
.stepup
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions') }}
    li.active
      span 店舗別接遇評価結果一覧

  .row.margin-top
    .col-sm-12
      //form
      div
        .form-inline(v-if="searchCallbackFlag")
          select.form-control(v-model="searchYear")
            option(:value="undefined") 年
            template(v-for="year in selectYears")
              option(:value="year") {{year}}年
          select.form-control(v-model="searchMonth")
            option(:value="undefined") 月
            template(v-for="i in 12")
              option(:value="i" :key="i + '月'") {{ i }}月
          button.btn.btn-info.margin-left(v-on:click="search(false)")
            i.fa.fa-search
            span 検索
          button.btn.btn-success.margin-left(v-on:click="goListDownload()" :disabled="!(searchYear&&searchMonth)" v-if="isHumanStaff || isSystemManagement || isShopMaster || isShopManager")
            i.fa.fa-download
            span 一覧出力
          button.btn.btn-primary.margin-left(v-on:click="goAllAnswerListDownload()" :disabled="!(searchYear&&searchMonth)" v-if="isHumanStaff")
            i.fa.fa-download
            span 全評価出力
          button.btn.btn-warning.margin-left(v-on:click="goNoAnswerListDownload()" :disabled="!(searchYear&&searchMonth)" v-if="isHumanStaff")
            i.fa.fa-download
            span 未入力確認出力

  div
    div(v-if="searchEnd && answers.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-3 店舗名
                th.col-sm-2 評価日
                th.col-sm-4 評価タイトル
                th.col-sm-2 総合評価
                th.col-sm-1
            tbody
              tr(v-for="answer in answers")
                td
                  span {{answer['shop_name']}}
                td
                  span {{answer['answer_start_date']}}
                td
                  span {{answer['service_question_title']}}
                td
                  span {{answer['point']}}
                td(style="text-align: right;")
                  a(v-on:click="goto(answer['shop_id'], answer['service_question_id'], answer['answer_start_date'])" v-if="shouldShowDetailButton(answer['shop_id'])").btn.btn-success.btn-sm 詳細

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && answers.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}

</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'service-question-shop-result',
  components: {
    AppHeader
  },
  data () {
    return {
      answers: [],
      searchEnd: false,
      nextExist: false,
      currentPage: 0,
      searchYear: undefined,
      searchMonth: undefined,
      searchCallbackFlag: false
    }
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return localStorage.is_shop_master === '1'
    },
    isShopManager () {
      return localStorage.is_shop_manager === '1'
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    selectYears () {
      let ret = []
      let startYear = 2019
      let today = new Date()
      let year = today.getFullYear()
      for (var i = startYear; i <= year; i++) {
        ret.push(i)
      }
      return ret
    }
  },
  created () {
    this.searchCallbackFlag = true

    // Set initial year/month values
    if (this.$route.query.year && this.$route.query.month) {
      // Use URL parameters if available
      this.searchYear = parseInt(this.$route.query.year)
      this.searchMonth = parseInt(this.$route.query.month)
    } else {
      // Use previous month as default
      const today = new Date()
      const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      this.searchYear = prevMonth.getFullYear()
      this.searchMonth = prevMonth.getMonth() + 1
    }

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  methods: {
    shouldShowDetailButton (shopId) {
      if (!this.isSystemManagement && !this.isHumanStaff && (this.isShopMaster || this.isShopManager)) {
        return parseInt(shopId) === parseInt(this.localShopId)
      }
      return true
    },
    async search (addSearch) {
      let data = {
        year: this.searchYear,
        month: this.searchMonth
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_SHOP_SERVICE_RESULT_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.answers = this.answers.concat(res)
      } else {
        this.answers = res
        this.searchEnd = true
      }
      this.nextExist = false
    },
    goto (shopId, serviceQuestionId, answerStartDate) {
      this.$router.push({
        path: '/service_question/results',
        query: {
          shop_id: shopId,
          year: this.searchYear,
          month: this.searchMonth
        }
      })
    },
    async goListDownload () {
      let data = {
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_SHOP_SERVICE_RESULT_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      await this.$store.dispatch('DELETE_SHOP_SERVICE_RESULT_LIST', { data: data })
    },
    async goAllAnswerListDownload () {
      let data = {
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_ALL_ANSWER_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      await this.$store.dispatch('DELETE_ALL_ANSWER_LIST', { data: data })
    },
    async goNoAnswerListDownload () {
      let data = {
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_NO_ANSWER_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      await this.$store.dispatch('DELETE_NO_ANSWER_LIST', { data: data })
    }
  }
}

</script>



// WEBPACK FOOTER //
// ServiceQuestionShopResultList.vue?e76f6690